import { useGetBillingSpendQuery } from 'store/api/apiSlice';

export const useCurrentSpend = () => {
  const { data, isLoading, isFetching, error } = useGetBillingSpendQuery();

  const websites = data?.websites ?? [];

  const counts = new Map<string, number>();
  websites.forEach(site => {
    counts.set(site.subscription, (counts.get(site.subscription) ?? 0) + 1);
  });
  const byProduct = Array.from(counts, ([name, count]) => ({ name, count }));

  return {
    isLoading,
    isFetching,
    error,
    websites,
    byProduct,
    billedTotal: data?.total ?? 0,
    currency: data?.currency ?? 'USD',
  };
};
